import React from 'react';
// import PropTypes from 'prop-types';
import { BiLogOut } from 'react-icons/bi';
import Button from 'modules/common/Button';
import default_logo from 'assets/img/logo.svg';
import AppWrapper from 'modules/common/AppWrapper';
import FitContent from 'modules/common/FitContent';
import { usePersistState } from 'utils/usePersistState';
import { usePartner } from 'modules/auth/hooks/usePartner';
// import { ThemeSwitcher } from 'modules/auth/hooks/useTheme';
import { logout } from 'modules/auth/actions';
import useGamesList from '../hooks/useGamesList';
import GameList from '../components/GameList';
import Filter from '../components/Filter';
import Wallet from '../components/Wallet';

function Homepage() {
  const [partner] = usePartner();
  const [filter, setFilter] = usePersistState('filter', {
    keyword: '',
    view: 'grid',
    favorite: 0,
  });
  const [isLoading, list, error] = useGamesList(filter);
  const handleLogout = () => {
    logout({}, () => {
      window.location.href = `/logout`;
    });
  };
  // console.log(auth);
  const emptyLabel = () => {
    if (filter?.favorite) return 'There are no favorites';
    return filter?.keyword
      ? 'No result found.'
      : 'There are no available games.';
  };

  return (
    <AppWrapper partner={partner}>
      <div className="py-2 flex items-center justify-center relative">
        <div className="absolute top-0 right-0 p-3">
          <Button transparent icon={BiLogOut} onClick={handleLogout} />
        </div>
        <img
          className="w-56 h-16 object-contain object-center"
          src={partner.account_logo || default_logo}
          alt="Logo"
        />
      </div>
      <div className="px-3 mb-3">
        <Filter onSubmit={setFilter} value={filter} />
      </div>
      <FitContent className="p-3">
        {error ? (
          <div className="text-center text-sm p-4 bg-red-500 rounded-md text-white">
            {error?.error === 'unauthorized'
              ? 'Another session by your account is detected. You will be automatically logout in 3 sec.'
              : error?.message || 'An error occured when loading games.'}
          </div>
        ) : (
          <GameList
            isLoading={isLoading}
            data={list}
            renderEmpty={emptyLabel()}
            viewMode={filter?.view}
          />
        )}
      </FitContent>
      <div>
        <Wallet />
      </div>
      {/* <ThemeSwitcher /> */}
    </AppWrapper>
  );
}

Homepage.propTypes = {};

export default Homepage;
